import * as React from 'react';
import { Component, Fragment } from 'react';
import { observer } from 'mobx-react';
import { action, observable } from 'mobx';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import { top } from '../utils/customPropStyles';
import Chevron from './Chevron';
import Translate from './Translate';
import ClickLayer from './ClickLayer';
import { ColumnGroupLabel } from './Grid';
import Tooltip from './Tooltip';

const ColumnDropdownWrapper = styled<any, any>('div')`
    ${propStyles};
`;

ColumnDropdownWrapper.defaultProps = {
    flex: "1 0 auto"
};

const ColumnDropdownInnerWrapper = styled<any, any>('div')`
    ${propStyles};
`;

ColumnDropdownInnerWrapper.defaultProps = {
    position: "relative"
};

const ColumnDropdownMenu = styled<any, any>('div')`
    ${propStyles};
    ${top};
`;

ColumnDropdownMenu.defaultProps = {
    position: "absolute",
    top: "calc(100% + 1px)",
    zIndex: "dropdown",
    width: ["100%", "80%"],
    margin: ["0", "0 10%"],
    bgColor: "white",
    borderWidth: "1px",
    borderColor: "gray300",
    borderStyle: "solid",
    borderRadius: "sm",
    boxShadow: "sm"
};

const ColumnDropdownList = styled<any, any>('ol')`
    ${propStyles};
    list-style: none;
    -ms-overflow-style: -ms-autohiding-scrollbar;
`;

ColumnDropdownList.defaultProps = {
    maxHeight: "300px",
    overflowX: "hidden",
    overflowY: "auto",
};

const ColumnDropdownListItem = styled<any, any>('li')`
    ${propStyles};
`;

ColumnDropdownListItem.defaultProps = {
    fontFamily: "body",
    fontWeight: "normal",
    paddingY: "sm",
    paddingX: "md",
    borderWidth: "1px",
    borderStyle: "none none solid none",
    borderColor: "gray300",
    cursor: "pointer",
    alternated: {
        bgColor: "gray100"
    },
    hover: {
        bgColor: "gray100"
    },
    selected: {
        color: "primary",
        fontWeight: "bold"
    }
};

type Column = {
    label: string;
    value: string;
    columnIndex: number,
    selectedGroupIndex: number,
    disclaimerTypes: Array<string>;
    disclaimers: Array<string>;
    options: Array<ColumnOptions>;
};

type ColumnOptions = {
    groupIndex: number;
    label: string;
};

interface ColumnDropdownProps {
    theme?: { [property: string]: string | number };
    column: Column;
    setSelectedGroup: Function;
    selectedGroupIndex: number;
}

@observer
class ColumnDropdown extends Component<ColumnDropdownProps> {
    @observable isOpen = false;

    @action 
    toggleOpen = () => {
        this.isOpen = !this.isOpen;
    }

    render() {
        const { props: { theme, column, selectedGroupIndex, setSelectedGroup }, isOpen, toggleOpen } = this;

        return (
            <ColumnDropdownWrapper
                {...theme.ColumnDropdownWrapper}
            >
                <ColumnDropdownInnerWrapper
                    {...theme.ColumnDropdownInnerWrapper}
                >
                    <ColumnGroupLabel
                        onClick={toggleOpen}
                        data-selected={isOpen}
                        cursor="pointer"
                        {...theme.ColumnGroupLabel}
                        {...theme.ColumnDropdownGroupLabel}
                    >
                        <Translate>{column.label}</Translate>
                        <Tooltip
                            content={column.disclaimers}
                            verticalAlign="sub"
                        />
                        <Chevron
                            fileName="ColumnDropdownChevronIcon"
                            direction={isOpen ? 'up' : 'down'}
                            display="inline-block"
                            verticalAlign="middle"
                            height="1em"
                            width="1em"
                            margin="0 0.5em"
                            {...theme.ColumnDropdownChevron}
                        />
                    </ColumnGroupLabel>
                    {
                        isOpen && (
                            <Fragment>
                                <ClickLayer
                                    onClick={toggleOpen}
                                />
                                <ColumnDropdownMenu
                                    {...theme.ColumnDropdownMenu}
                                >
                                    <ColumnDropdownList
                                        {...theme.ColumnDropdownList}
                                    >
                                        {
                                            column.options.map(o =>
                                                <ColumnDropdownListItem
                                                    key={o.groupIndex}
                                                    onClick={() => { toggleOpen(); setSelectedGroup(column.columnIndex, o.groupIndex); }}
                                                    data-alternated={o.groupIndex % 2 ? true : false}
                                                    data-selected={o.groupIndex === selectedGroupIndex}
                                                    {...theme.ColumnDropdownListItem}
                                                >
                                                    <Translate>{o.label}</Translate>
                                                </ColumnDropdownListItem>
                                            )
                                        }
                                    </ColumnDropdownList>
                                </ColumnDropdownMenu>
                            </Fragment>
                        )
                    }
                </ColumnDropdownInnerWrapper>
            </ColumnDropdownWrapper>
        );
    }
}

export default withTheme(ColumnDropdown);


// WEBPACK FOOTER //
// ./src/Components/ColumnDropdown.tsx